<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Design system components
	import { Alert, Text } from '@Shelly/shelly-design-system';
	//Components
	import NavigateToIp from './NavigateToIP.svelte';

	export let isOffline: boolean = false;
	export let connected: boolean,
		ip: string | boolean = false,
		ssid: string | boolean = false,
		classes: string = '';
</script>

<div class="mt-s mb-s {classes}">
	<Alert
		type={isOffline && connected ? 'warning' : !isOffline && connected ? 'success' : 'danger'}
		heading={isOffline && connected
			? $format('device_status_offline', { default: 'Device is offline' })
			: connected
				? $format('device_status_connected', { default: 'Device is connected' })
				: $format('device_status_disconnected', {
						default: 'Device is disconnected',
					})}
		isHeadingBold
		hideSlotBottom={typeof ip != 'string' || !connected}
	>
		<svelte:fragment slot="bottom">
			{#if isOffline}
				<Text styleType="body-small" class="mb-s">
					{$format('alert_warning_last_known_network_configuration', {
						default: 'Last known network configuration:',
					})}
				</Text>
			{/if}
			<NavigateToIp {ssid} {ip} />
		</svelte:fragment>
	</Alert>
</div>
